<!-- 
    FORM PARA INCLUSAO/ALTERACAO DE FUNIL








https://vuejsexamples.com/a-fast-and-lightweight-drag-drop-sortable-library-for-vue-js/



FALTA 
- drag and drop



-->

<script>
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import { arrayMoveIndex } from '../shared/utils'
import { SysVars } from '../main';
import Vue from 'vue';
import draggable from "vuedraggable";
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        index: '',
        crud: '',
    },
    
    components: {
        draggable
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            funil: {
                codfunil: null,
                descricao: null,
                data: null,
                codusuario: null,
            },

            etapas: [ 
                // { descricao: 'Cliente Potencial', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
                // { descricao: 'Contato Realizado', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
                // { descricao: 'Visita Técnica', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
                // { descricao: 'Proposta Feita', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
                // { descricao: 'Negociação em Andamento', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
            ],

            idxExcluindoEtapa: null,

            transferEtapas: [],

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        optionsTransferEtapas: function () {
            return this.transferEtapas.map(function (obj) {
                    return { id: obj.codetapa, text: obj.descricao }
            })
        },

        countEtapas: function () {
            return this.etapas.filter(obj => { return !obj.excluida }).length
        },
    },

    methods: {

        handleSalvar () {
            var valido = true;

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    this.funil.etapas = this.etapas
                    this.apiFunil(this.funil, null, this.callBackPost)
                }
            })

        },

        callBackPost (funil) {
            if (this.index)
                this.$erpToastSuccess('Funil alterado com sucesso')
            else
                this.$erpToastSuccess('Novo funil criado com sucesso')
            this.closeForm(funil)
        },

        closeForm (funil) {
            this.$store.dispatch('loadFunilCrm', {} )
            this.$emit('closeform', funil)
        },

        async loadData () {
            await this.$store.dispatch('loadFunilCrm', { id: this.index } )
            if (this.$store.getters.getFunilCrm) {
                this.funil = {...this.$store.getters.getFunilCrm}
                this.etapas = this.funil.etapas
            }
        },

        /////////////////////////////////// etapas
        handleAdicionarEtapa () {
            this.etapas.push({
                descricao: 'Nova Etapa',
                probabilidade: 0,
                diasestagnado: 0,
                excluida: false,
                transfer_to_codetapa: null,
            })
        },

        handleShowDeleteEtapa (index) {
            if (this.etapas[index].count_negocios > 0) {
                this.transferEtapas = this.etapas
                this.transferEtapas.splice(index, 1)
            } else {
                this.transferEtapas = []
            }
            this.idxExcluindoEtapa = index
        },

        excluindoEtapa(index) {
            return this.idxExcluindoEtapa == index
        },

        handleDeleteEtapa (index) {
            //EXCLUIR ETAPA
            this.etapas[index].excluida = true
            this.idxExcluindoEtapa = null
        },


        handleMoverEtapa (index, position) {
            arrayMoveIndex(this.etapas, index, position)

            for (var x = 0; x < this.etapas.length; x++) {
                this.etapas[x].sequencia = x+1
            }

        }

    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.descricao) {
               this.$refs.descricao.focus()
            }
        })
    },

    created () {
        if (this.index) {
            this.loadData()
        }
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <!-- <div class="container nb-modal-scrollable-container" style="max-width: 100%"> -->
        <div class="container nb-modal-scrollable-container" style="width: 700px; max-width: 100%">
            <div class="nb-modal-scrollable-body">
                <div class="row">
                    <div class="col-md-4 col-12">
                        <h4 class="def-title"> Funil </h4>
                    </div>
                    <div class="col-md-8 col-12">
                        <div class="float-right">
                            <v-button label="Cancelar" title="" icon="fa-arrow-left" @click="closeForm"></v-button>
                            <v-button label="Salvar" title="" :nb-btdef="true" @click="handleSalvar"></v-button>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <form-field ref="descricao" v-model="funil.descricao" type="text" col="12" :metadata="metadata.funilcrm.descricao"
                        name="descricao" :v-errors="errors" v-validate="metadata.funilcrm.descricao.validator"></form-field>
                </div>

                <!-- etapas -->
                <label-title title="Etapas do Funil"></label-title>

                <div v-for="(etapa, index) in etapas" :key="index">
                    <div v-if="!etapa.excluida" class="card mb-3 p-3">
                        <div v-if="!excluindoEtapa(index)" class="row align-items-center">
                            <form-field v-model="etapa.descricao" type="text" col="6" :metadata="metadata.etapacrm.descricao" case="normal"
                                name="descricao" :v-errors="errors" v-validate="metadata.etapacrm.descricao.validator"></form-field>
                            <form-field v-model="etapa.probabilidade" type="number" col="3" :metadata="metadata.etapacrm.probabilidade" 
                                name="probabilidade" :v-errors="errors" addon="%" v-validate="metadata.etapacrm.probabilidade.validator"></form-field>
                            <form-field v-model="etapa.diasestagnado" type="number" col="3" :metadata="metadata.etapacrm.diasestagnado" 
                                name="diasestagnado" :v-errors="errors" addon="Dias" v-validate="metadata.etapacrm.diasestagnado.validator"></form-field>
                            <div v-if="etapa.count_negocios" class="col-12">
                                <label class="lbl-edit">Negócios Vinculados Nesta Etapa</label>
                                <span class="data-list">{{ etapa.count_negocios }}</span>
                            </div>
                            <div class="col-12">
                                <v-button v-if="!excluindoEtapa(index) && countEtapas != 1" icon="fa-trash" @click="handleShowDeleteEtapa(index)"></v-button>
                                <v-button v-if="index != 0" icon="fa-arrow-up" @click="handleMoverEtapa(index, -1)"></v-button>
                                <v-button v-if="index != etapas.length-1" icon="fa-arrow-down" @click="handleMoverEtapa(index, 1)"></v-button>
                            </div>
                        </div>
                        <div v-if="excluindoEtapa(index)" class="row">
                            <div class="col-md-12 col-12">
                                <span class="data-list"> Excluir Etapa: <strong> {{ etapa.descricao }} </strong> </span>
                            </div>
                            <div class="col-md-12 col-12" v-if="etapa.count_negocios">
                                <span class="data-list">Existem negócios vinculados nesta etapa. Selecione para qual etapa serão movimentados estes negócios:</span>
                            </div>
                            <form-field v-if="etapa.count_negocios" v-model="etapa.transfer_to_codetapa" type="select" col="6" :select-options="optionsTransferEtapas"></form-field>
                            <div class="col-md-12 col-12">
                                <v-button label="Confirmar" @click="handleDeleteEtapa(index)"></v-button>
                                <v-button label="Cancelar" @click="idxExcluindoEtapa = null"></v-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row col mt-3">
                    <a style="cursor: pointer; color: #0091ea;" @click="handleAdicionarEtapa">Adicionar Nova Etapa</a>
                </div>
                <div class="mb-5">

                </div>
            </div>
        </div>
    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-funil-form.vue